import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";
import { Grid2, IconButton } from "@mui/material";
import log from "loglevel";
import React from "react";
import { connect } from "react-redux";
import { actions } from "../logic/relatedFilmsFormActions";
import "./styles.scss";
import {DATE_FORMAT_ONLY_YEAR, DATE_FORMAT_HOUR_AM_PM, DATE_FORMAT_SHORT, formatDate} from "components/common/dateUtils";

const RelatedItem = (props) => {
    const { item, toggleRelatedFilmsForm } = props;

    log.debug("item", item);

    const handleEdit = () => {
        toggleRelatedFilmsForm(true, item.id);
    };

    return (
        (<Grid2 className="table-item" size={12}>
            <Grid2 className="actions" size={1}>
                <IconButton size="small" onClick={handleEdit}>
                    <ModeEditOutlineIcon />
                </IconButton>
            </Grid2>
            <Grid2
                size={{
                    xs: 8,
                    md: 8
                }}>
                <Grid2 size={12}>
                    {item.filmRelease.title}
                </Grid2>
                <Grid2 size={12}>
                    {item.filmRelease.filmReleaseTypeId.abbreviation} / {item.filmRelease.filmRatingTypeId.name} /{" "}
                    {formatDate(item.filmRelease.enteredDate, DATE_FORMAT_ONLY_YEAR)}
                </Grid2>
                <Grid2 size={12}></Grid2>
            </Grid2>
            <Grid2
                size={{
                    xs: 3,
                    md: 3
                }}>
                <Grid2 size={12}>
                    {item.advertisementFilmReleaseAssociationType.name}
                </Grid2>
                <Grid2 size={12}>
                    {formatDate(item.dateOccurred, DATE_FORMAT_SHORT)}
                </Grid2>
                <Grid2 size={12}>
                    {formatDate(item.timeOccurred, DATE_FORMAT_HOUR_AM_PM)}
                </Grid2>
            </Grid2>
        </Grid2>)
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggleRelatedFilmsForm: (editing, id) => dispatch(actions.TOGGLE_RELATED_FILM_FORM.send({ editing, id })),
    };
};

export default connect(null, mapDispatchToProps)(RelatedItem);
